import { Button, Icon, Menu } from "@fidelix/fx-miranda";
import { ComponentProps } from "react";
import { createSearchParams, useNavigate } from "react-router-dom";
import { Key } from "react-stately";
import { styled } from "styled-components";
import { useNavigatonPath } from "../../utils/url";
import { getActiveRoute } from "../../common/nav-bar";
import { PointGroupLite } from "../point.model";

type Props = {
  pointGroups: PointGroupLite[];
} & Omit<ComponentProps<typeof Button>, "onPress">;

export function ViewGroupHistoryButton({ pointGroups, ...rest }: Props) {
  const navigate = useNavigate();
  const { to } = useNavigatonPath();

  if (pointGroups.length === 0) {
    return null;
  }

  if (pointGroups.length === 1) {
    const path = to(
      `history?${createSearchParams({ groupId: String(pointGroups[0].id), from: getActiveRoute() }).toString()}`,
    );
    return (
      <Button
        onPress={() => navigate(path)}
        icon="chevronRight"
        iconPlacement="right"
        {...rest}
      />
    );
  }

  const onMenuSelect = (key: Key) => {
    const path = to(
      `history?${createSearchParams({ groupId: String(key), from: getActiveRoute() }).toString()}`,
    );
    navigate(path);
  };

  return (
    <Menu
      onAction={onMenuSelect}
      trigger={<Button icon="chevronDown" iconPlacement="right" {...rest} />}
    >
      {pointGroups.map((g) => (
        <Menu.Item key={g.id} id={g.id}>
          <MenuItemContainer>
            {g.name}
            <Icon icon="chevronRight" size={24} />
          </MenuItemContainer>
        </Menu.Item>
      ))}
    </Menu>
  );
}

const MenuItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${(p) => p.theme.space("medium")};
`;
